import React from 'react';
import { useParams } from 'react-router-dom';
import TrainingWorkspace from '../components/TrainingWorkspace';

export { relatedTrainingDocuments } from '../components/TrainingWorkspace';

const TrainingDocument: React.FC = () => {
  const { documentId } = useParams();
  return <TrainingWorkspace primaryKind="document" primaryId={documentId} />;
};

export default TrainingDocument;
